var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4 py-4"},_vm._l((_vm.votes),function(item,index){return _c('div',{key:index,staticClass:"col-lg-6 mx-auto"},[_c('vote',{attrs:{"vote":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }